import * as React from 'react';
import clsx from 'clsx';

interface DeleteInputProps {
  value: string;
  onChange: (val: string) => void;
}

export const DeleteInput: React.FC<DeleteInputProps> = ({ value, onChange }) => (
  <div className='mb-8 w-full'>
    <label className='mb-2 block font-sans text-16 font-bold text-brand-800'>
      Type DELETE to confirm.
    </label>
    <p className='mb-2 font-sans text-14 font-normal text-brand-800'>
      This action requires confirmation.
    </p>
    <input
      type='text'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder='Type DELETE'
      className={clsx(
        'h-[48px] w-[300px] px-4',
        // Border & Shape: 1.5px solid #D33C3E, Radius 10px
        'rounded-10 border-1.5 border-delete-input',
        // Background
        'bg-white',
        // Typography: Inter V, SemiBold (600), 16px, 160% line-height, -2% letter spacing
        'font-sans text-16 font-semibold leading-160 tracking-[-0.02em]',
        // Text Color (spec: #D33C3E) and placeholder
        'text-delete-input placeholder:text-delete-input',
        // Focus State
        'focus:outline-none focus:ring-1 focus:ring-delete-input'
      )}
    />
  </div>
);
